import dayjs from "@/lib/helpers/dayjs";

export type DateFields = {
  displayDate: string | null;
  displayTime: string | null;
  isoDate: string | null;
};

// completed_date_time is stored as UTC; parse with utc() then convert to local
// for display (consistent with resolveIcaDates).
export function formatCompletedDateTime(completedDateTime: Nullable<string>): DateFields {
  if (!completedDateTime) return { displayDate: null, displayTime: null, isoDate: null };

  const local = dayjs.utc(completedDateTime).local();

  return {
    displayDate: local.format("MM/DD/YYYY"),
    displayTime: local.format("hh:mm A"),
    isoDate: local.toISOString(),
  };
}
